var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-card', { attrs: { "shadow": "never" } }, [_c('div', { attrs: { "slot": "header" }, slot: "header" }, [_c('span', [_vm._v("产品补充信息")])]), _vm._v(" "), _c('m-form', { ref: "form", attrs: { "form-config": _vm.formConfig, "form-item-list": _vm.formItemList, "form-value": _vm.demand } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };